import gql from 'graphql-tag';

export default gql`
    query GetEquipmentsInfo($input: GetEquipmentsInfoInput) {
        getEquipmentsInfo(input: $input) {
            sandbox {
                itemId
                descrip
                status
            }
            stand {
                itemId
                descrip
                status
            }
            forklift {
                itemId
                descrip
                status
            }
            auriser {
                itemId
                descrip
                status
            }
            dustcollector {
                itemId
                descrip
                status
            }
            generator {
                itemId
                descrip
                status
            }
            telehandler {
                itemId
                descrip
                status
            }
            frontendloader {
                itemId
                descrip
                status
            }
            skidsteer {
                itemId
                descrip
                status
            }
            standbase {
                itemId
                descrip
                status
            }
            chassis {
                itemId
                descrip
                status
            }
            otherequipment {
                itemId
                descrip
                status
            }
            mobileoffice {
                itemId
                descrip
                status
            }
            auger {
                itemId
                descrip
                status
            }
            guardian {
                itemId
                descrip
                status
            }
            aquabox {
                itemId
                descrip
                status
            }
            cradle {
                itemId
                descrip
                status
            }
        }
    }
`;
